var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydraulicOil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0066 28.346C43.2867 34.0655 46.5667 39.7851 49.8468 45.521C54.2365 53.1471 48.7534 62.6961 40.0066 62.6961C31.2598 62.6961 25.7767 53.1471 30.1501 45.521C33.4465 39.8015 36.7266 34.0655 40.0066 28.346ZM32.092 46.6386C28.5835 52.7691 32.9733 60.428 40.0066 60.428C47.04 60.428 51.4297 52.7691 47.9049 46.6386C45.2775 42.0367 42.6339 37.4348 40.0229 32.8493C37.3793 37.4512 34.7357 42.0367 32.1084 46.6386H32.092Z",
    fill: "#231815"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 16.644H37.3453V3.19977H42.6325V16.644H55.1653V21.969H24.8125V16.644Z",
    fill: "#231815"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.0533H21.2709V71.8013H58.706V10.0533H63.977V77.1099H16V10.0533Z",
    fill: "#231815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydraulicOil);
export default __webpack_public_path__ + "static/media/HYDRAULIC_OIL.110ff76c0ffd0d49e0002aae3771bba4.svg";
export { ForwardRef as ReactComponent };